import * as Backbone from 'backbone';
import * as _ from 'underscore';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    errors: [],
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Calculation: {}
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    "sync": function (method, model, options) {
        if (method == 'read') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/-1';
        } else if (method == 'create') {
            options.url =  config.webApiUrl() + '/api/publicRecaptcha/' + options.route + '/-1';
        } 
        return Backbone.sync(method, model, options);
    },
    initialize: function () {
        var that = this;
    },
    validateNoBackbone: function (attrs, app, callback) {
        this.errors = [];

        var self = this;

        //var tmpModel = {};
        //tmpModel.Method = 'GetEmailUsed';
        //tmpModel.Value = attrs.Email;

        //app.entities.collections.publicCustom.fetch ({
        //    silens : true,
        //    wait : true,
        //    tmpModel: tmpModel,
        //    success: function (mode, response) {
        //        callbackInternal(false);
        //    },
        //    error : function (mode, response) {
        //        callbackInternal(true);
        //    },
        //});

        

        var callbackInternal = function (error) {

            //Fields required
            if (error) {
                self.errors.push({ name: 'register_inputEmail', message: resources.X100599 });
            }

            if (!attrs.FirstName) {
                self.errors.push({ name: 'register_inputFirstName', message: resources.X100324 });
            }

            var checkCompanyRegistration = false;
            switch (attrs.Organisation) {
                case 0 :  checkCompanyRegistration = false; break;
                case 1 :  checkCompanyRegistration = true; break;
                case 2 :  checkCompanyRegistration = false; break;
            }
            if (checkCompanyRegistration) {
                if (!attrs.CompanyRegistration) {
                    self.errors.push({ name: 'register_inputCompanyRegistration', message: resources.X100324 });
                }
        
                //^(\d){8}$
                var validate_CompanyRegistration = app.entities.collections.publicConfigSubscriptionValidate.where( {Name : 'register_inputCompanyRegistration'});
                if (validate_CompanyRegistration && validate_CompanyRegistration.length > 0) {
                    var re = new RegExp(validate_CompanyRegistration[0].attributes.Value, 'g');
                    if(attrs.CompanyRegistration.match(re) == null) {
                        self.errors.push({ name: 'register_inputCompanyRegistration', message: validate_CompanyRegistration[0].attributes.Error });
                    }
                }
            }

            var checkAttPerson = false;
            switch (attrs.Organisation) {
                case 0 :  checkAttPerson = false; break;
                case 1 :  checkAttPerson = true; break;
                case 2 :  checkAttPerson = true; break;
            }
            if (checkAttPerson) {
                if (!attrs.AttPerson) {
                    self.errors.push({ name: 'register_inputAttPerson', message: resources.X100324 });
                }
            }

            if (!attrs.Address) {
                self.errors.push({ name: 'register_inputAddress', message: resources.X100324 });
            }

            if (!attrs.WrongAddress) {
                self.errors.push({ name: 'register_inputAddress', message: resources.X100287 });
            }

            if (!attrs.Phone) {
                self.errors.push({ name: 'register_inputPhone', message: resources.X100324 });
            }

            if (!attrs.Email) {
                self.errors.push({ name: 'register_inputEmail', message: resources.X100324 });
            }
            //^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$
            var validate_Email = app.entities.collections.publicConfigSubscriptionValidate.where( {Name : 'register_inputEmail'});
            if (validate_Email && validate_Email.length > 0) {
                var re = new RegExp(validate_Email[0].attributes.Value, 'g');
                if(attrs.Email.match(re) == null) {
                    self.errors.push({ name: 'register_inputEmail', message: validate_Email[0].attributes.Error });
                }
            }

            if (!attrs.Password) {
                self.errors.push({ name: 'register_inputPassword', message: resources.X100324 });
            }
            //^(?=.*[a-z].*[a-z])(?=.*[A-Z].*[A-Z])(?=.*\d.*\d)(?=.*\W.*\W)[a-zA-Z0-9\S]{9,}$
            var validate_Password = app.entities.collections.publicConfigSubscriptionValidate.where( {Name : 'register_inputPassword'});
            if (validate_Password && validate_Password.length > 0) {
                var re = new RegExp(validate_Password[0].attributes.Value, 'g');
                if(attrs.Password.match(re) == null) {
                    self.errors.push({ name: 'register_inputPassword', message: validate_Password[0].attributes.Error });
                }
            }
        

            if (!attrs.PasswordConfirm) {
                self.errors.push({ name: 'register_inputPasswordConfirm', message: resources.X100324 });
            }
            if (attrs.PasswordConfirm != attrs.Password) {
                self.errors.push({ name: 'register_inputPasswordConfirm', message: resources.X100597 });
            }

            if (self.errors.length > 0) {
                callback(false);
                //return true
            }
            else {
                callback(true);
                //return false;
            }
        }
        //return errors.length > 0 ? errors : false, 

        callbackInternal(false);
    }
});

    